import * as constant from './constants';

const INITIAL_STATE_DSR = {
  choiceDSRFor: { label: 'Sendiri', id: 'sendiri' }, // Default value
  modalMobileState: {
    isOpen: false,
    isTitle: '',
    typeModal: '',
    options: [],
    selectedOption: '',
  },

  visibleGlobalModalContent: {
    title: '',
    content: '',
    ctaTitle: '',
    visible: false,
    status: '',
  },

  documentSupportPermohonan: {
    file: '',
    fileType: '',
    fileName: '',
    status: '',
    error: '',
    content: null,
  },

  documentSupportWali: {
    file: '',
    fileType: '',
    fileName: '',
    status: '',
    error: '',
    content: null,
  },

  formDsrData: {
    category: '',
    fullname: '',
    categoryId: '',
    phone: '',
    email: '',
    province: '',
    city: '',
    address: '',
    message: '',
    forPeople: '',
    subjectRelationPermohonan: '',
    descriptionPermohonan: '',
    zipcode: '',
    fullnameWali: '',
    phoneWali: '',
    documentSupportWali: '',
    subjectRelationWali: '',
    imageWali: '',
    emailWali: '',
    detailPermohonan: '',
  },
};

const dsrReducer = (state = INITIAL_STATE_DSR, action: { type: string; payload?: any }) => {
  switch (action.type) {
    case constant.SET_CHOICE_DSR_FOR:
      return {
        ...state,
        choiceDSRFor: action.payload,
      };
    case constant.SET_DSR_STATE:
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };
    case constant.SET_VISIBLE_GLOBAL_MODAL_CONTENT:
      return {
        ...state,
        visibleGlobalModalContent: action.payload,
      };
    default:
      return state;
  }
};

export default dsrReducer;
